var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical_search",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M23.222,17.222V15h2.222v2.222h2.222v2.222H25.444v2.222H23.222V19.444H21V17.222Z",
    transform: "translate(-6.667 -4)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M17.667,22.667a8.333,8.333,0,1,0-6.228-2.8l-.644.644-.947.066L6,24.429,7.571,26,11.4,22.176l.088-.778.748-.748A8.3,8.3,0,0,0,17.667,22.667Zm0-1.111a7.222,7.222,0,1,0-7.222-7.222A7.222,7.222,0,0,0,17.667,21.556Z",
    fill: "#9c8eeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M11.854,19.5l.348.392.391.336A7.742,7.742,0,0,0,17.305,22.1a7.778,7.778,0,0,1-7.412-7.511A7.745,7.745,0,0,0,11.854,19.5Zm-.813,1.553-.947.066L6.786,24.429l.786.786,3.294-3.294.088-.778Zm.354,1.122L7.571,26,6,24.429l3.848-3.848.947-.066.644-.644a8.331,8.331,0,1,1,.792.779l-.748.748Zm5.715-8.4H14.889v1.111h2.222v2.222h1.111V14.889h2.222V13.778H18.222V11.556H17.111ZM18.778,11v2.222H21v2.222H18.778v2.222H16.556V15.444H14.333V13.222h2.222V11Zm6.111,3.333a7.222,7.222,0,1,1-7.222-7.222A7.222,7.222,0,0,1,24.889,14.333Z",
    fill: "#9c8eeb",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationsIcon);
export default __webpack_public_path__ + "static/media/consultations-icon.444fcc0160b4271a06bbec280e5ff9a3.svg";
export { ForwardRef as ReactComponent };